import React, {useEffect, useState, useCallback} from "react";
import axios from "axios";
import DataTables from "./components/TransactionsTable";

function AgentTransactions() {
    const [count, setCount] = useState(0);
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [sortField, setSortField] = useState("");
    const [orderBy, setOrderBy] = useState(false);
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const [errorMsg] = useState("");
    const [deleteGroupsIds, setDeleteGroupsIds] = useState([]);
    const [filterInputs, setFilterInputs] = useState({
        transactionDateTimeStart: "",
        transactionDateTimeEnd: ""
    })


    const onGroups = () => {
        setIsLoading(true);
        axios
            .get(`agent/getAllCPTransactions`, {
                params: {
                    skip, take, orderBy,
                    ...(filterInputs.transactionDateTimeStart && {transactionDateTimeStart: filterInputs.transactionDateTimeStart}),
                    ...(filterInputs.transactionDateTimeEnd && {transactionDateTimeEnd: filterInputs.transactionDateTimeEnd})
                }
            })
            .then(({data: {data, count}}) => {
                setIsLoading(false);
                setGroups(data);
                setIsError(false);
                setCount(count)
            })
            .catch(() => {
                setIsLoading(false);
                setGroups([]);
                setIsError(true);
            });
    };

    const filterInputsUpdate = useCallback((e) => {
        if(e.target) {
            setFilterInputs(prevState => ({
                ...prevState,
                [e.target.name]: e.target.value
            }))
        }
    }, [])

    const resetFilter = useCallback(() => {
        setFilterInputs({
            transactionDateTimeStart: "",
            transactionDateTimeEnd: ""
        })
    }, [])

    useEffect(() => {
        onGroups();
    }, [sortField, orderBy, skip, take, filterInputs]);

    return (
       <>
            <DataTables
                groups={groups}
                count={count}
                isLoading={isLoading}
                isError={isError}
                errorMsg={errorMsg}
                setDeleteGroupsIds={setDeleteGroupsIds}
                deleteGroupsIds={deleteGroupsIds}
                skip={skip}
                setSkip={setSkip}
                take={take}
                setTake={setTake}
                sortField={sortField}
                setSortField={setSortField}
                orderBy={orderBy}
                setOrderBy={setOrderBy}
                filterInputs={filterInputs}
                filterInputsUpdate={filterInputsUpdate}
                resetFilter={resetFilter}
                setFilterInputs={setFilterInputs}
            />
       </>
    );
}

export default AgentTransactions;
